import { PayloadAction } from '@reduxjs/toolkit';
import { RealtimeState } from 'shared/store/realtime-slice';
import { Trigger } from 'types';
import { createKit, createRealtimeReducerActions } from './kit';

type PA<T> = PayloadAction<T>;

/**
 * Takeover flow rough outline
 *
 * 1) Reducer sets takeover establishing state based on isTakeoverWanted
 * 2) When rt visitor state reflects the active takeover state, consider takeover active
 * 3) Once takeover is active, rrweb component will start sending takeover events
 *
 */

/****************************************************
 *
 *                 Reducers
 *
 ****************************************************/
const reducers = {
  takeoverWanted: (state: RealtimeState, action: PA<boolean>) => {
    state.optimisticInteractions = {
      ...state.optimisticInteractions,
      isTakeover: action.payload,
    };
  },

  takeoverRejected: (state: RealtimeState) => {
    state.takeoverStatus = 'rejected';
    state.optimisticInteractions = {
      ...state.optimisticInteractions,
      isTakeover: false,
    };
  },
};
// Access actions before createSlice so we can reference them locally
const actions = createRealtimeReducerActions({ reducers });

export const takeoverKit = createKit({
  reducers,

  /****************************************************
   *
   *               Handle triggers
   *
   ****************************************************/
  triggerThunkHelper: (trigger, _, dispatch) => {
    if (trigger === Trigger.STOP_TAKEOVER) {
      dispatch(actions.takeoverWanted(false));
    } else if (trigger === Trigger.REJECT_TAKEOVER) {
      dispatch(actions.takeoverRejected());
    }
  },

  /****************************************************
   *
   *         Visitor sync/update reducer helpers
   *
   ****************************************************/
  visitorUpdateReducer: () => null,

  /****************************************************
   *
   *               Kit hook
   *
   ****************************************************/
  useKitHook: () => null,
});
